import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler,
  Legend,
  ChartOptions,
  Plugin,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler,
  Legend,
);

const innerBorder: Plugin<'line'> = {
  id: 'innerBorder',
  beforeDraw(chart: any) {
    const { ctx, chartArea, scales } = chart;
    const xItems = (scales.x as any)._gridLineItems;
    const yItems = (scales.y as any)._gridLineItems;
    if (!xItems?.length || !yItems?.length) return;

    const xPos = xItems[0].x;
    const yPos = yItems[0].y;

    ctx.save();
    ctx.lineWidth = (scales.x.options.border?.width as number) || 2;
    ctx.strokeStyle = (scales.x.options.border?.color as string) || '#ccc';

    ctx.beginPath();
    ctx.moveTo(xPos, chartArea.top);
    ctx.lineTo(xPos, chartArea.bottom);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(chartArea.left, yPos);
    ctx.lineTo(chartArea.right, yPos);
    ctx.stroke();
    ctx.restore();
  },
};

interface OverviewChartProps {
  chartData: { label: string; value: number }[];
}

export default function LineChart({ chartData }: OverviewChartProps) {
  const data = {
    labels: chartData.map((d) => d.label),
 datasets: [
  {
    data: chartData.map((d) => d.value),
    borderColor: '#FF0050',
    borderWidth: 2,
    pointRadius: 3,
    pointHoverRadius: 8,
    pointHoverBackgroundColor: '#FF0050',
    pointHoverBorderColor: '#fff',
    pointHoverBorderWidth: 2,
    hitRadius: 20,
  },
],
  };

const options: ChartOptions<'line'> = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: { display: false, offset: true },
      border: { display: true, width: 2, color: '#ccc' },
    },
    y: {
      beginAtZero: true,
      grid: {
        display: true,
        offset: true,
        lineWidth: 1,
        color: '#0000000D',
        drawTicks: false,
      },
      border: { display: true, width: 2, color: '#ccc' },
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      enabled: true,
      backgroundColor: '#FF0050',
      titleColor: '#ffffff',
      bodyColor: '#ffffff',
      titleFont: {
        size: 16,
        weight: 'bold',
      },
      bodyFont: {
        size: 14,
      },
      padding: 14,
      cornerRadius: 10,
      displayColors: false,
      caretSize: 8,
      bodySpacing: 6,
    },
  },
};

  return (
    <div className='relative bg-white'>
      <div className='bg-white' style={{ height: 270 }}>
        <Line data={data} options={options} plugins={[innerBorder]} />
      </div>
    </div>
  );
}
